import * as alarms from '@wix/auto_sdk_motion_alarms';
import * as metroinspector from '@wix/auto_sdk_motion_metroinspector';
import * as products from '@wix/auto_sdk_motion_products';

export { alarms, metroinspector, products };
